/**
 * @generated SignedSource<<f3cac3246e899d8a9ca90e8beb80ce1e>>
 * @relayHash af5291ada4a908f6c2a58f597a8ca947
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 57cedf702b2fe356a4affe4b7a7087d367cb24ca910dd0e7b48587ef8059ca8e

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardEmbedQuery } from './src_jiraBusinessBoardEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "57cedf702b2fe356a4affe4b7a7087d367cb24ca910dd0e7b48587ef8059ca8e",
    "metadata": {},
    "name": "src_jiraBusinessBoardEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
